import "antd/dist/antd.min.css";
import { useStateValue } from "./shared/state/StateProviders";
import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { ConfigProvider, Empty } from "antd";

// User (patient) panel
import HomeLayout from "./shared/layout/HomeLayout";
import ClientLogin from "./panels/user/ClientLogin";
import ClientBooking from "./panels/user/Client_Booking";
import ClientDashboard from "./panels/user/ClientDashboard";
import Clientchangepassword from "./panels/user/Clientchangepassword";
import ClientProfilesettings from "./panels/user/ClientProfilesettings";
import ContactUs from "./shared/pages/contact/ContactUs";
import AboutUs from "./shared/pages/about/AboutUs";
import Appointmentbookingsuccessfullypopup from "./panels/user/Appointmentbookingsuccessfullypopup";
import ClientDetailsRegister from "./panels/user/ClientDetailsRegister";
import NewclientRegister from "./panels/user/NewclientRegister";
import ClientForgotPassword from "./panels/user/ClientForgotPassword";
import Invoice from "./shared/invoice/Invoice";

import Footer from "./shared/components/Footer";
import Header from "./shared/components/Header";

// Admin panel (routes under /administration)
import Adminlayout from "./panels/admin/Adminlayout";
import AdminDashboard from "./panels/admin/Admin_Dashboard";
import AdminClients from "./panels/admin/AdminClients";
import AdminClientProfile from "./panels/admin/AdminClientProfile";
import AdminChangePassword from "./panels/admin/AdminChangePassword";
import Events from "./panels/admin/Events";
import Offers from "./panels/admin/Offers";
import AdminMessages from "./panels/admin/AdminMessages";
import AddPrescription from "./panels/admin/AddPrescription";
import Newsletter from "./panels/admin/Newsletter";
import AdminSidebar from "./panels/admin/AdminSidebar";
import AdminForgotPassword from "./panels/admin/AdminForgotPassword";
import Topbar from "./shared/components/Topbar";
import DoctorAppointmentByDate from "./panels/admin/AdminAppointmentByDate";
import Notfound from "./shared/components/Notfound";
import Termsandconditions from "./shared/pages/Termsandconditions";
import Privacypolicy from "./shared/pages/Privacypolicy";
import Shippingpolicy from "./shared/pages/Shippingpolicy";
import Transaction from "./panels/admin/Transaction";
import Returnrefund from "./shared/pages/Returnrefund";
import AdminTrash from "./panels/admin/AdminTrash";

// Clinic panel — routes under /clinic
import Cliniclayout from "./panels/clinic/Cliniclayout";
import ClinicDashboard from "./panels/clinic/Clinic_dashboard";
import ClinicAppointmentByDate from "./panels/clinic/ClinicAppointmentByDate";
import ClinicChangePassword from "./panels/clinic/ClinicChangePassword";
import Clinictrash from "./panels/clinic/Clinictrash";
import Clinictransaction from "./panels/clinic/ClinicTransaction";
import ClinicSidebar from "./panels/clinic/ClinicSidebar";
import Clinicforgetpassword from "./panels/clinic/Clinicforgetpassword";
import ClinicAddReceptionist from "./panels/clinic/Clinic_add_receptionist";
import ClinicAddDoctor from "./panels/clinic/ClinicAddDoctor";
import ClinicViewDoctor from "./panels/clinic/ClinicViewDoctor";
import ClinicClients from "./panels/clinic/ClinicClient";
import Clinicclientprofile from "./panels/clinic/Clinicclientprofile";

// Doctor panel — routes under /doctor
import DoctorLayout from "./panels/doctor/DoctorLayout";
import DoctorLogin from "./panels/doctor/DoctorLogin";
import DoctorDashboard from "./panels/doctor/Doctor_dashboard";
import DoctorScheduleTimings from "./panels/doctor/Doctor_Schedule_Timings";
import DoctorAppointmentByDatePanel from "./panels/doctor/DoctorAppointmentByDate";
import DoctorProfileSettings from "./panels/doctor/DoctorProfileSettings";
import DoctorChangePassword from "./panels/doctor/DoctorChangePassword";
import DoctorTransaction from "./panels/doctor/DoctorTransaction";
import DoctorForgetPassword from "./panels/doctor/DoctorForgetPassword";

// Receptionist panel
import ReceptionistDashboard from "./panels/receptionist/Receptionist_dashboard";
import ReceptionistAppointmentByDate from "./panels/receptionist/ReceptionistAppointmentByDate";
import ReceptionistScheduleTimings from "./panels/receptionist/Receptionist_Schedule_Timings";
import ReceptionistChangePassword from "./panels/receptionist/ReceptionistChangePassword";
import ReceptionistSidebar from "./panels/receptionist/ReceptionistSidebar";
import Receptionistforgetpassword from "./panels/receptionist/Receptionistforgetpassword";
import Receptionistlayout from "./panels/receptionist/Receptionistlayout";
import Myclinic from "./panels/admin/Myclinic";
import Clinicsprofile from "./panels/admin/Clinicsprofile";
import Addpackage from "./panels/admin/Addpackage";
import ClinicProfilesettings from "./panels/clinic/ClinicProfilesettings";
import Receptionistprofilesetting from "./panels/receptionist/Receptionistprofilesetting";
import Receptionistevents from "./panels/receptionist/ReceptionistEvents";
import Receptionistoffers from "./panels/receptionist/Receptionistoffers";
import Clinicoffers from "./panels/clinic/Clinicoffers";
import Clinicevents from "./panels/clinic/Clinicevents";
import Registeruser from "./panels/admin/Registeruser";
import Downloadapp from "./shared/components/Downloadapp";
import ClinicPromoCode from "./panels/clinic/ClinicPromoCode";
import AdminPromoCode from "./panels/admin/AdminPromoCode";

window.API_PREFIX = "https://apiappointilo.morphosistec.com/";
// window.API_PREFIX =
//   "https://appointilo-backend-711335464374.asia-south1.run.app/";

window.WEBSOC = "wss://" + String(window.API_PREFIX).split("//")[1];

function App() {
  const [{ IsRegister }] = useStateValue();

  return (
    <>
      <ConfigProvider
        renderEmpty={() => <Empty description="Record not found" />}
      >
        <Routes path="">
          <Route path="" element={<HomeLayout />}>
            <Route path="login" element={<ClientLogin />} />
            <Route path="booking" element={<ClientBooking />} />
            <Route path="dashboard" element={<ClientDashboard />} />
            <Route path="change-password" element={<Clientchangepassword />} />
            <Route path="profile-setting" element={<ClientProfilesettings />} />
            <Route
              path="client-detail-register"
              element={<ClientDetailsRegister />}
            />
            <Route path="" element={<ClientLogin />} />
            <Route
              path="bookingsuccessfully"
              element={<Appointmentbookingsuccessfullypopup />}
            />
          </Route>
          <Route path="about" element={<AboutUs />} />
          <Route path="contact" element={<ContactUs />} />
          <Route
            path="/forget-password"
            element={
              <>
                <Header />
                <ClientForgotPassword />
                <Footer />
              </>
            }
          />
          <Route
            path="/client-detail-register"
            element={
              <>
                <Header />
                {!IsRegister ? <ClientDetailsRegister /> : null}
                <Footer />
              </>
            }
          />
          <Route
            path="/register"
            element={
              <>
                <Header />
                <NewclientRegister />
                <Footer />
              </>
            }
          />
          <Route path="invoice" element={<Invoice />} />
          <Route path="download-app" element={<Downloadapp />} />

          <Route path="/administration" element={<Adminlayout />}>
            <Route path="myclinic" element={<Myclinic />} />
            <Route
              path="clinicprofile/:PID/doctor/:doctorId"
              element={<ClinicViewDoctor />}
            />
            <Route path="clinicprofile/:PID" element={<Clinicsprofile />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="trash" element={<AdminTrash />} />
            <Route path="my-clients" element={<AdminClients />} />
            <Route path="clientprofile/:PID" element={<AdminClientProfile />} />
            <Route
              path="administrationchangepassword"
              element={<AdminChangePassword />}
            />
            <Route path="mitwanktrasactions" element={<Transaction />} />
            <Route path="mitwankoffers" element={<Offers />} />
            <Route path="mitwankevents" element={<Events />} />
            <Route path="mitwankpromocode" element={<AdminPromoCode />} />
            <Route path="eventattandes" element={<Registeruser />} />
            <Route path="add-package" element={<Addpackage />} />
            <Route path="clientmessages" element={<AdminMessages />} />
            <Route path="addprescription" element={<AddPrescription />} />
            <Route path="newsletter" element={<Newsletter />} />
            <Route path="doctorsidebar" element={<AdminSidebar />} />
            <Route
              path="mitwankappointmentbydate"
              element={<DoctorAppointmentByDate />}
            />
          </Route>
          <Route
            path="/adminforgetpassword"
            element={
              <>
                <Topbar />
                <Header />
                <AdminForgotPassword />
                <Footer />
              </>
            }
          />
          <Route path="/*" element={<Notfound />} />
          <Route
            path="terms-and-conditions"
            element={
              <>
                <Header />
                <Termsandconditions />
                <Footer />
              </>
            }
          />
          <Route
            path="privacy-policy"
            element={
              <>
                <Header />
                <Privacypolicy />
                <Footer />
              </>
            }
          />
          <Route
            path="return-and-refund-policy"
            element={
              <>
                <Header />
                <Returnrefund />
                <Footer />
              </>
            }
          />
          <Route
            path="shipping-policy"
            element={
              <>
                <Header />
                <Shippingpolicy />
                <Footer />
              </>
            }
          />

          <Route path="/clinic" element={<Cliniclayout />}>
            <Route
              path="clinic-add-receptionist"
              element={<ClinicAddReceptionist />}
            />
            <Route path="clinic-add-doctor" element={<ClinicAddDoctor />} />
            <Route
              path="view-doctor/:doctorId"
              element={<ClinicViewDoctor />}
            />
            <Route path="clinictransactions" element={<Clinictransaction />} />
            <Route path="dashboard" element={<ClinicDashboard />} />
            <Route path="trash" element={<Clinictrash />} />
            <Route path="profile-setting" element={<ClinicProfilesettings />} />
            <Route
              path="clinicchangepassword"
              element={<ClinicChangePassword />}
            />
            <Route path="clinictransaction" element={<Clinictransaction />} />
            <Route path="clinicoffers" element={<Clinicoffers />} />
            <Route path="clinicevents" element={<Clinicevents />} />
            <Route path="doctorsidebar" element={<ClinicSidebar />} />
            <Route
              path="clinicappointmentbydate"
              element={<ClinicAppointmentByDate />}
            />
            <Route path="clinic-clients" element={<ClinicClients />} />
            <Route
              path="clientprofile/:PID"
              element={<Clinicclientprofile />}
            />
            <Route path="clinicpromocode" element={<ClinicPromoCode />} />
          </Route>
          <Route
            path="/clinicforgetpassword"
            element={
              <>
                <Header />
                <Clinicforgetpassword />
                <Footer />
              </>
            }
          />

          <Route path="/doctor" element={<DoctorLayout />}>
            <Route path="dashboard" element={<DoctorDashboard />} />
            <Route path="schedule-timing" element={<DoctorScheduleTimings />} />
            <Route
              path="appointment-by-date"
              element={<DoctorAppointmentByDatePanel />}
            />
            <Route path="transactions" element={<DoctorTransaction />} />
            <Route path="profile-setting" element={<DoctorProfileSettings />} />
            <Route path="change-password" element={<DoctorChangePassword />} />
          </Route>
          <Route
            path="/doctorforgetpassword"
            element={
              <>
                <Header />
                <DoctorForgetPassword />
                <Footer />
              </>
            }
          />

          <Route path="/receptionist" element={<Receptionistlayout />}>
            <Route
              path="schedule-timing"
              element={<ReceptionistScheduleTimings />}
            />
            <Route path="dashboard" element={<ReceptionistDashboard />} />
            <Route
              path="receptionistprofilesettings"
              element={<Receptionistprofilesetting />}
            />
            <Route
              path="receptionistchangepassword"
              element={<ReceptionistChangePassword />}
            />
            <Route path="receptionistoffers" element={<Receptionistoffers />} />
            <Route path="receptionistevents" element={<Receptionistevents />} />
            <Route path="doctorsidebar" element={<ReceptionistSidebar />} />
            <Route
              path="receptionistappointmentbydate"
              element={<ReceptionistAppointmentByDate />}
            />
          </Route>
          <Route
            path="/receptionistforgetpassword"
            element={
              <>
                <Header />
                <Receptionistforgetpassword />
                <Footer />
              </>
            }
          />
        </Routes>
      </ConfigProvider>

      <Toaster />
    </>
  );
}

export default App;
